module.exports = __webpack_public_path__ + "img/dermatology-aesthetic.00abd7bb.png";